
/**
* @component HalfLayout
*
* @public
*/

export default {
  name: 'HalfLayout',
  props: {
    inverse: {
      type: Boolean,
    },
    center: {
      type: Boolean,
    },
  },
};
